import React from 'react';
import styled from 'styled-components';
import type { Locale } from '@peloton/internationalize/models/locale';
import { gray1, gray2 } from '@engage/colors';
import type { Caption } from '@engage/settings';
import { spaces } from '@engage/styles';
import { header6Small } from '@engage/typography';
import { Checkbox } from './inputs';

export const SubtitleOption: React.FC<React.PropsWithChildren<Props>> = ({
  checkboxId,
  caption,
  toggleSubtitle,
}) => (
  <>
    <Divider data-test-id="subtitle-option-divider" />
    <SubtitleRow htmlFor={checkboxId}>
      {caption.localeName}
      <Checkbox
        id={checkboxId}
        checked={caption.enabled}
        onChange={() => toggleSubtitle(caption.locale)}
      />
    </SubtitleRow>
  </>
);

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${gray2};
`;

const SubtitleRow = styled.label`
  height: 50px;
  width: 100%;
  background-color: ${gray1};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${spaces.medium}px;
  cursor: pointer;
  ${header6Small}

  &:last-child {
    border-radius: 0 0 ${spaces.xxSmall}px ${spaces.xxSmall}px;
  }
`;

type Props = {
  checkboxId: string;
  caption: Caption;
  toggleSubtitle: (subtitleLocale: Locale) => void;
};
